// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusSquareFilledSvg from "@fishx/icons-svg/es/asn/PlusSquareFilled";
import FishxIcon from '../components/FishxIcon';

var PlusSquareFilled = function PlusSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareFilledSvg
  }));
};

PlusSquareFilled.displayName = 'PlusSquareFilled';
export default React.forwardRef(PlusSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusSquareFilled.js
// module id = 3824
// module chunks = 0